// extracted by mini-css-extract-plugin
export var disabled = "_s-6";
export var hierarchyLinkGray = "_s-a";
export var hierarchyLinkUnderline = "_s-9";
export var hierarchyPrimary = "_s-0";
export var hierarchySecondary = "_s-7";
export var hierarchyTertiary = "_s-8";
export var pressed = "_s-2";
export var themeAction = "_s-1";
export var themeDestructive = "_s-4";
export var themeNormal = "_s-3";
export var themeSuccess = "_s-5";